interface Properties {
  width?: number;
  height?: number;
}

const DashboardIcon = ({ width = 24, height = 24 }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_684_1056)'>
        <path
          d='M33.8013 33.8C30.9294 33.8 28.6013 36.1281 28.6013 39V46.8C28.6013 49.672 30.9294 52 33.8013 52H33.8637C37.1218 52 39.9176 51.829 42.2534 51.3098C44.6191 50.784 46.6698 49.8675 48.2693 48.268C49.8688 46.6685 50.7853 44.6179 51.311 42.2521C51.5494 41.1794 51.7067 40.0905 51.81 38.9946C52.0796 36.1354 49.6733 33.8 46.8013 33.8H33.8013Z'
          fill='black'
        />
        <path
          d='M0.000854492 33.8624V28.6C0.000854492 25.7281 2.32897 23.4 5.20085 23.4H18.2009C21.0728 23.4 23.4009 25.7281 23.4009 28.6V46.8C23.4009 49.672 21.0728 52 18.2009 52H18.1385C14.8803 52 12.0847 51.8289 9.74864 51.3097C7.38311 50.784 5.33254 49.8675 3.73297 48.268C2.1334 46.6685 1.21693 44.6178 0.691207 42.2521C0.172039 39.9163 0.000854492 37.1205 0.000854492 33.8624Z'
          fill='black'
        />
        <path
          d='M52.0013 23.4C52.0013 26.272 49.6733 28.6 46.8013 28.6H33.8013C30.9294 28.6 28.6013 26.272 28.6013 23.4V5.2C28.6013 2.32812 30.9294 0 33.8013 0H33.8637C37.1218 0 39.9176 0.171184 42.2534 0.690352C44.6191 1.21607 46.6698 2.13255 48.2693 3.73212C49.8688 5.33169 50.7853 7.38226 51.311 9.74779C51.8302 12.0838 52.0013 14.8795 52.0013 18.1376V23.4Z'
          fill='black'
        />
        <path
          d='M23.402 5.2C23.402 2.32812 21.074 0 18.202 0H18.1396C14.8815 0 12.0858 0.171184 9.74979 0.690352C7.38425 1.21607 5.33369 2.13255 3.73412 3.73212C2.13454 5.33169 1.21807 7.38226 0.692351 9.74779C0.453905 10.8207 0.296553 11.9096 0.193255 13.0055C-0.0762354 15.8647 2.33012 18.2 5.202 18.2H18.202C21.074 18.2 23.402 15.8719 23.402 13V5.2Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_684_1056'>
          <rect width='52' height='52' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DashboardIcon;
